import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs/Observable";
import { TranslationType } from "../models/translation-type";
import { Translation } from "../models/translation";
import { environment } from "../../environments/environment";
import { Language } from "../models/language";
import { HttpClient } from "@angular/common/http";
import { SportingEvent } from "../models/sportingEvent";

@Injectable()
export class TranslationService {
  /**
   * Load dependencies
   * @param {ApiService} apiService
   * @param {HttpClient} http
   */
  constructor(private apiService: ApiService, private http: HttpClient) {}

  /**
   * Fetch all translation types from the API
   * @param {Language} language
   * @returns {Observable<TranslationType[]>}
   */
  getTranslationTypes(language: Language): Observable<TranslationType[]> {
    return this.apiService
      .get("Translate/GetTranslationTypes?languageId=" + language.id)
      .map((res) => {
        if (res && res.values) {
          return res.values.map((value) => new TranslationType(value));
        }
      });
  }

  getTranslationsByType(
    translationTypeId: number,
    languageId: number,
    index: number = 0,
    limit: number = 50,
    orderByDescending: string = "false",
    orderOn: number = 1,
    keywords: string = "",
    translated: boolean = null
  ) {
    return this.apiService
      .get(
        "Translate/Search?translationTypeId=" +
          translationTypeId +
          "&languageId=" +
          languageId +
          "&index=" +
          index +
          "&limit=" +
          limit +
          "&orderByDescending=" +
          orderByDescending +
          "&orderOn=" +
          orderOn +
          "&keywords=" +
          keywords +
          "&translated=" +
          translated
      )
      .map((data) => {
        const translationsModel = [];
        if (data.values) {
          data.values.map((translation) => {
            translationsModel.push(new Translation(translation));
          });
        }
        return { translations: translationsModel, count: data.values.length };
      });
  }

  getTooltip(translationTypeId: number, elementId: number) {
    return this.apiService
      .get(
        "Translate/Tooltip?translationTypeId=" +
          translationTypeId +
          "&elementId=" +
          elementId
      )
      .map((data) => {
        if (data.value) {
          return data.value;
        }
      });
  }

  saveTranslations(translations: Translation[]) {
    return this.apiService.post("Translate/SaveTranslations", translations);
  }

  getGoogleTranslation(query: string, target: string, source: string) {
    const url =
      environment.apiTranslateUrl +
      "&q=" +
      query.replace("#", "") +
      "&target=" +
      target +
      "&source=" +
      source +
      "&format=text";
    return this.http.get(url, { withCredentials: false });
  }

  getTranslationById(
    elementId: number,
    translationTypeId: string,
    languageId: number
  ) {
    return this.apiService
      .get(
        "Translate/GetByIds?id=" +
          elementId +
          "&translationTypeId=" +
          translationTypeId +
          "&languageId=" +
          languageId
      )
      .map((res) => {
        if (res && res.value) {
          return new Translation(res.value);
        }
      });
  }

  placeholderPictogram(translation: any) {
    return this.apiService.post("Translate/PlaceholderPictogram", translation);
  }

  deletePictogram(translation: any, pictureId: number) {
    return this.apiService.post(
      "Translate/DeletePictogram/" + pictureId,
      translation
    );
  }

  updatePictures(translation: any) {
    return this.apiService.post("Translate/UploadPictures", translation);
  }

  getSportingEvents(translationTypeId: number, translationId: number) {
    return this.apiService
      .get(
        "Translate/GetSportingEvents?type=" +
          translationTypeId +
          "&elementId=" +
          translationId
      )
      .map((res) => {
        if (res && res.values) {
          return res.values.map((value) => new SportingEvent(value));
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/translation.service.ts